import { Box, Tab, Tabs } from '@mui/material';
import React, { SyntheticEvent, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TabPanel } from 'ui';
import Images from './Images';
import Info from './Info';
import { useApi } from 'hooks';
import { UseQueryResult } from '@tanstack/react-query';
import { components } from 'apis';
type GetPresignedURLImageLinkResponse =
    components['schemas']['GetVideoUploadLinkResponse'];

const Customization: React.FC = () => {
    const { username } = useParams();
    const { api } = useApi();
    const [submitting, setSubmitting] = useState<boolean>(false);
    if (username === undefined) {
        return <div>Not Found</div>;
    }
    const updateInfo = api.useMutation('patch', '/channel/info');
    const [currentTab, setCurrentTab] = useState<number>(0);
    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };
    const uploadImages = async (avatarImage?: File, bannerImage?: File) => {
        setSubmitting(true);
        if (avatarImage) {
            const getAvatarImageUploadLink: UseQueryResult<GetPresignedURLImageLinkResponse> =
                api.useQuery(
                    'get',
                    `/media/imageUploadLink?path=avatar&fileName=${avatarImage.name}&fileType=${avatarImage.type}`,
                    {},
                    { enabled: false },
                );
            const avatarImageData = new FormData();
            avatarImageData.append('file', avatarImage);
            avatarImageData.append('path', `${username}/channel/avatar`);
            avatarImageData.append('newName', username);
            const res = await getAvatarImageUploadLink.refetch();
            if (res.data) {
                await fetch(res.data?.url, {
                    method: 'PUT',
                    body: avatarImage,
                    headers: {
                        ContentType: avatarImage.type,
                    },
                });
            }
            await updateInfo.mutateAsync({
                body: {
                    avatarThumbnail: avatarImage.name,
                },
            });
        }
        if (bannerImage) {
            const getBannermageUploadLink: UseQueryResult<GetPresignedURLImageLinkResponse> =
                api.useQuery(
                    'get',
                    `/media/imageUploadLink?path=banner&fileName=${bannerImage.name}&fileType=${bannerImage.type}`,
                    {},
                    { enabled: false },
                );
            const bannerImageData = new FormData();
            bannerImageData.append('file', bannerImage);
            bannerImageData.append('path', 'banner');
            bannerImageData.append('newName', username);
            const res = await getBannermageUploadLink.refetch();
            if (res.data) {
                await fetch(res.data?.url, {
                    method: 'PUT',
                    body: bannerImage,
                    headers: {
                        ContentType: bannerImage.type,
                    },
                });
            }
            await updateInfo.mutateAsync({
                body: {
                    bannerThumbnail: bannerImage.name,
                },
            });
        }
        setSubmitting(false);
    };
    const updateChannelInfo = async (bio: string, description: string) => {
        setSubmitting(true);
        await updateInfo.mutateAsync({
            body: {
                bio: bio,
                description: description,
            },
        });
        setSubmitting(false);
    };
    const accountInfo = api.useQuery(
        'get',
        '/channel/info/{channelId}',
        { params: { path: { channelId: username } } },
        {
            refetchInterval: Infinity,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        },
    );
    if (accountInfo.isLoading) {
        return <div>Loading</div>;
    }
    if (accountInfo.isError || !accountInfo.data) {
        return <div>error</div>;
    }
    return (
        <>
            <Box
                sx={{ paddingTop: 5, borderBottom: 1, borderColor: 'divider' }}
            >
                <Tabs value={currentTab} onChange={handleChange}>
                    <Tab label="Details" />
                    <Tab label="Images" />
                </Tabs>
            </Box>
            <Box sx={{ width: '50vw' }}>
                <TabPanel currentIndex={currentTab} tabIndex={0}>
                    <Info
                        bio={accountInfo.data.bio}
                        description={accountInfo.data.description}
                        username={username}
                        updateChannelInfo={updateChannelInfo}
                        submitting={submitting}
                    />
                </TabPanel>
                <TabPanel currentIndex={currentTab} tabIndex={1}>
                    <Images
                        username={username}
                        avatarThumbnail={accountInfo.data?.avatarThumbnail}
                        bannerThumbnail={accountInfo.data?.bannerThumbnail}
                        submitting={submitting}
                        uploadImages={uploadImages}
                    />
                </TabPanel>
            </Box>
        </>
    );
};

export default Customization;
